import { useCallback, useEffect, useState } from "react";
import AnimatedList from "../../lists/AnimatedList";
import useApplause from "@/hooks/useApplause";

let seq = 0;
let interval = null;

function LiveWireTickerWidget({}) {
  const [list, setList] = useState([]);

  const addItem = useCallback(() => {
    // If the list has more than 50 items, remove the first 25 items
    // This is to prevent the list from growing indefinitely
    if (list.length === 50) {
      setList([...list.slice(25), { id: seq++ }]);
    } else {
      setList([...list, { id: seq++ }]);
    }
  }, [list, setList]);

  // Every 10 seconds add a new item
  useEffect(() => {
    const addInterval = setInterval(() => {
      addItem();
    }, 6000);
    return () => clearInterval(addInterval);
  }, [addItem]);

  return (
    <div className="live-wire-ticker widget" style={{ minWidth: 300 }}>
      <div className="card card-rounded">
        <div className="p-3 pb-1 d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <span className="bi bi-bell-fill text-orange me-2 fs-24"></span>
            <div
              className="fw-bold text-black flex-fill fs-18"
              onClick={addItem}
            >
              Ding Tracker
            </div>
          </div>

          <div>
            <span className="avatar avatar-xs bg-orange-transparent avatar-rounded blob">
              <i className="bi bi-circle-fill fs-8"></i>
            </span>
          </div>
        </div>
        <div
          className="card-body px-3 py-2 overflow-y-scroll"
          style={{ height: 0 }}
        >
          <AnimatedList
            items={list}
            renderItem={(item, x) => <Ticker data={item} />}
          />
        </div>
      </div>
    </div>
  );
}

export const Ticker = ({ data = {} }) => {
  return (
    <div className="card ticker mb-2">
      <div className="card-body p-2">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <div className="me-1">
            <div className="position-relative">
              <span className="avatar avatar-lg avatar-rounded">
                <img src={`https://i.pravatar.cc/100?u=${data.id}`} alt="" />
              </span>
              <div
                className="position-absolute bottom-0 "
                style={{ right: -5 }}
              >
                <span
                  className={`fs-8 avatar avatar-xs avatar-rounded bg-orange`}
                >
                  +1
                </span>
              </div>
            </div>
          </div>
          <div className="flex-fill">
            <h5 className="d-block fw-semibold fs-14 mb-1">Leanne White</h5>
            <div className="d-flex justify-content-between align-items-center">
              {/* <div className="text-muted fs-12">Sent to QA</div> */}
              <div className="text-muted fs-12">a few seconds ago</div>
            </div>
          </div>
          <div className="me-1">
            <span className={`avatar avatar-xs bg-primary`}>{data.id}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveWireTickerWidget;
